import BookingsPage from './pages/BookingsPage'
import CreateInventoryPage from './pages/CreateInventoryPage'
import DashboardPage from './pages/DashboardPage'
import FlightsDataPage from './pages/FlightsDataPage'
import ReleaseManagerPage from './pages/ReleaseManagerPage'
import { OfflineFlightProviders } from './providers'

function withProviders(Page: () => JSX.Element) {
  return function OfflineFlightRoute() {
    return (
      <OfflineFlightProviders>
        <Page />
      </OfflineFlightProviders>
    )
  }
}

export const OfflineFlightSearch = withProviders(DashboardPage)
export const OfflineFlightCreate = withProviders(CreateInventoryPage)
export const OfflineFlightBookings = withProviders(BookingsPage)
export const OfflineFlightFlights = withProviders(FlightsDataPage)
export const OfflineFlightReleaseManager = withProviders(ReleaseManagerPage)
